import { memo, useState } from "react";
import { Container, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import { Link } from "react-router-dom";

const HeaderBox = () => {
    const [menu, setMenu] = useState(false);

    return (
        <>
            <Container fluid className="mt-4 mb-4 font-size-16">
                <Row >
                    <h2>
                        PROFILE

                        <Dropdown
                            isOpen={menu}
                            toggle={() => setMenu(menu => !menu)}
                            className="dropdown d-inline"
                            tag="li"
                        >
                            <DropdownToggle
                                className="btn header-item noti-icon position-relative"
                                tag="button"
                                id="page-header-notifications-dropdown"
                            >
                                <i className="mdi mdi-dots-vertical font-size-20 text-primary" />
                            </DropdownToggle>

                            <DropdownMenu className="dropdown-menu dropdown-menu-start">
                                <Link
                                    tabIndex={0}
                                    role="menuitem"
                                    className="dropdown-item"
                                    to="/profile/edit"
                                >Edit Profile</Link>
                            </DropdownMenu>
                        </Dropdown>
                    </h2>
                </Row>
            </Container>
        </>
    );
};

export default memo(HeaderBox);
